import React, { useState, useEffect, useContext } from "react"
import { Button, ButtonGroup, Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import DatePicker from "react-datepicker"
import toast from "react-hot-toast"
import Select from "react-select"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import * as XLSX from "xlsx"

// components
import AddModal from "./Components/AddPIModal"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/DataTable"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import Footer from "../../../Components/Footer/Footer"

// api calls and utils
import {
  createBir2037PurchaseInvoice,
  deleteInvoice,
  filterInvoice,
} from "../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi"
import {
  getType,
  isAdmin,
  refreshPage,
  toastStyle,
  TokenExpiry,
  numberFormat,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
// css
import "./PurchaseInvoices.css"
import "../PurchaseOrders/PurchaseOrders.css"
import CloseBillModal from "./Components/CloseBillModal"
import Moment from "moment"

import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import PIModal from "./Components/PIModal"
import GenerateBirModal from "../PurchaseOrders/Components/GenerateBirModal"
import BirForm from "../Pay Suppliers/Components/BirForm"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"
/**
 *  Purchase Invoice component
 */
export default function PurchaseInvoices() {
  let navigate = useNavigate()
  const accountType = getType()
  const [inactive, setInactive] = useState(true)
  const [suppliers, setSuppliers] = useState([])
  const [branches, setBranches] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [excelData, setExcelData] = useState([])
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)

  const [grandTotal, setGrandTotal] = useState(0)
  const [totalPaidAmount, setTotalPaidAmount] = useState(0)
  const [totalBalance, setTotalBalance] = useState(0)
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)

  const xlsxHeaders = [
    "DATE",
    "SUPPLIER",
    "BRANCH",
    "INV NO.",
    "DR NO.",
    "SUBTOTAL",
    "AMOUNT DUE",
    "AMT. PAID",
    "BAL.",
    "PYMNT STATS",
    "PMT REF NO",
    "PO NO.",
  ]
  const overpaidHeaders = [
    "DATE",
    "SUPPLIER",
    "BRANCH",
    "INV NO.",
    "DR NO.",
    "SUBTOTAL",
    "AMOUNT DUE",
    "AMT. PAID",
    "OVERPAID.",
    "PYMNT STATS",
    "PMT REF NO",
    "PO NO.",
  ]

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)
  const [PIID, setPIID] = useState("")

  /* Close bill Modal */
  const [showCloseBillModal, setShowCloseBillModal] = useState(false)
  const handleShowCloseBillModal = () => setShowCloseBillModal(true)
  const handleCloseCloseBillModal = () => setShowCloseBillModal(false)

  const [bill, setBill] = useState([])

  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = useState({
    supplier: "",
    date_from: dateFilter.date_from ? dateFilter.date_from : "",
    date_to: dateFilter.date_to ? dateFilter.date_to : "",
    invoice_no: "",
    type: "",
    branch_id: "",
    page: 1,
    // payment_status: currentTab ? currentTab : "open",
  })

  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setFilterConfig((prev) => {
      return {
        ...prev,
        payment_status: tabKey,
        vendor_id: "",
        branch_id: "",
        supplier_id: "",
        date_from: dateFilter.date_from
          ? dateFilter.date_from
          : tabKey === "" || tabKey === "closed"
          ? aweekago
          : "",
        date_to: dateFilter.date_to
          ? dateFilter.date_to
          : tabKey === "" || tabKey === "closed"
          ? today
          : "",
        page: "1",
      }
    })
  }

  const handleFilterChange = (e) => {
    setCurrentPage(1)
    const { name, value } = e.target
    if (name === "supplier") {
      var id = value.split("|")[0]
      var by = value.split("|")[2]
      if (by === "supplier") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            supplier: id,
            supplier_id: id,
            vendor_id: "",
            page: 1,
          }
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            supplier: "",
            supplier_id: "",
            vendor_id: id,
            page: 1,
            // type: type,
          }
        })
      }
    } else {
      if (name === "type") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            [name]: value,
            supplier: "",
            supplier_id: "",
            vendor_id: "",
            page: 1,
          }
        })
        setSelectedSupplier({
          label: "All Suppliers",
          value: "",
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            [name]: value,
            page: 1,
          }
        })
      }
    }
  }

  const [purchaseInvoiceManager, setPurchaseInvoiceManager] = useState([])
  async function searchPurchaseInvoice() {
    setShowLoader(true)
    setPurchaseInvoiceManager([])
    setExcelData([])
    setGrandTotal("0")
    setTotalPaidAmount("0")
    setTotalBalance("0")
    setTotalItems(0)

    const response = await filterInvoice(filterConfig)

    var allBills = []

    if (response.data) {
      var sortedData = response.data.data.sort((a, b) =>
        a.receive_date > b.receive_date
          ? 1
          : b.receive_date > a.receive_date
          ? -1
          : 0
      )

      sortedData.map((data) => {
        data.type = ""
        data.balance = data.balance ? numberFormat(data.balance) : ""
        data.total = data.grand_total ? numberFormat(data.grand_total) : ""
        data.discounted_subtotal = data.discounted_subtotal
          ? numberFormat(data.discounted_subtotal)
          : ""
        data.amount_paid = data.paid_amount
          ? numberFormat(data.paid_amount)
          : ""
        data.overpaid_amount = data.overpaid_amount
          ? numberFormat(data.overpaid_amount)
          : ""
        data.supplier = data.supplier_name
          ? data.supplier_name
          : data.vendor_name
        data.receive_date = Moment(data.receive_date).format("MMM DD, YYYY")
        data.payment_status =
          parseFloat(data.overpaid_amount) > 0
            ? data.payment_status + " - " + data.remarks
            : data.payment_status
        data.pay_ref_no = !data.payments
          ? ""
          : data.payments
              .map((data) => {
                return data.doc_no
              })
              .join(", ")
        data.return_details = !data.purchase_returns
          ? ""
          : data.purchase_returns
              .map((data) => {
                return "No. " + data.id + " - " + data.replacement_type
              })
              .join(", ")
        allBills.push(data)
      })

      var grandtotal = response.data.summary ? response.data.summary.total : "0"
      var totalpaid = response.data.summary
        ? response.data.summary.total_paid
        : "0"
      var totalbalance = response.data.summary
        ? response.data.summary.total_balance
        : "0"
      setGrandTotal(grandtotal)
      setTotalPaidAmount(totalpaid)
      setTotalBalance(totalbalance)
      setTotalItems(response.data.size)
    } else {
      TokenExpiry(response)
    }

    if (
      filterConfig.payment_status === "open" ||
      filterConfig.payment_status === "closed" ||
      filterConfig.payment_status === ""
    ) {
      var excel = allBills.map((bill) => {
        var info = {}
        info.receive_date = bill.receive_date
        info.supplier = bill.supplier
        info.branch_name = bill.branch_name
        info.invoice_no = bill.invoice_no
        info.dr_no = bill.dr_no
        info.discounted_subtotal = bill.discounted_subtotal
        info.total = bill.total
        info.amount_paid = bill.amount_paid
        info.balance = bill.balance
        info.payment_status = bill.payment_status
        info.pay_ref_no = bill.pay_ref_no
        info.return_details = bill.return_details
        info.po_id = bill.po_id
        return info
      })
      setExcelData(excel)
    } else if (filterConfig.payment_status === "overpaid") {
      const excel = allBills.map((bill) => {
        var info = {}
        info.receive_date = bill.receive_date
        info.supplier = bill.supplier
        info.branch_name = bill.branch_name
        info.invoice_no = bill.invoice_no
        info.dr_no = bill.dr_no
        info.discounted_subtotal = bill.discounted_subtotal
        info.total = bill.total
        info.amount_paid = bill.amount_paid
        info.overpaid_amount = bill.overpaid_amount
        info.payment_status = bill.payment_status
        info.pay_ref_no = bill.pay_ref_no
        info.return_details = bill.return_details
        info.po_id = bill.po_id
        return info
      })
      setExcelData(excel)
    }
    setPurchaseInvoiceManager(allBills.reverse())
    setShowLoader(false)
  }

  function handleExport() {
    const rows = excelData.reverse()

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    if (filterConfig.payment_status === "open") {
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "OpenPurchaseInvoices.xlsx", {
        compression: true,
      })
    } else if (filterConfig.payment_status === "closed") {
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "ClosedPurchaseInvoices.xlsx", {
        compression: true,
      })
    } else if (filterConfig.payment_status === "") {
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "AllPurchaseInvoices.xlsx", {
        compression: true,
      })
    } else if (filterConfig.payment_status === "overpaid") {
      XLSX.utils.sheet_add_aoa(worksheet, [overpaidHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "OverpaidPurchaseInvoices.xlsx", {
        compression: true,
      })
    }
  }

  async function fetchBranches() {
    // setShowLoader(true);
    setBranches([])
    const response = await getAllBranches()
    if (response.data) {
      // var allBranches = response.data.data.data.filter((company) => { return company.is_franchise === "0"})
      var allBranches = response.data.data.data.map((data) => {
        var branch = data
        // branch.name = "branch_id"
        branch.label = data.name
        branch.value = data.id
        return branch
      })
      setBranches([{ label: "All Branches", value: "" }, ...allBranches])
    }
  }

  function ContractBtn(row) {
    // return (
    //   <ButtonGroup vertical>
    //     <>
    //       {row.payments?.map((row) => {
    //         return (
    //           <button
    //             type="button"
    //             className="button-secondary table-button me-3"
    //             onClick={() => handleViewContract(row.id, row.payment_mode)}
    //           >
    //             {row.doc_no}
    //           </button>
    //         )
    //       })}
    //     </>
    //   </ButtonGroup>
    // )
  }
  function handleViewContract(id, payment_mode) {
    window.open("/paysuppliers/view/" + id + "/" + payment_mode, "_blank")
  }

  function ReturnBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.purchase_returns?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button me-3"
                onClick={() => handleViewReturn(row.id)}
              >
                {`No. ${row.id} - ${row.replacement_type}`}
              </button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }
  function handleViewReturn(id) {
    window.open("/purchasereturn/view/" + id, "_blank")
  }

  useEffect(() => {
    searchPurchaseInvoice()
  }, [filterConfig, currentPage])

  const [showLoader, setShowLoader] = useState(false)

  const [supplierList, setSupplierList] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState({
    label: "All Suppliers",
    value: "",
  })

  useEffect(() => {
    setSupplierList(
      suppliers.map((supplier) => {
        return {
          label: supplier.trade_name,
          value: supplier.id + "|" + supplier.type,
        }
      })
    )
    setSupplierList((branches) => {
      var newBranches = [...branches]
      newBranches.push({ label: "All Suppliers", value: "" })
      return newBranches.reverse()
    })
  }, [suppliers])

  function handleSupplierChange(e) {
    setSelectedSupplier({
      label: e.label,
      value: e.value,
    })
    const toFilter = { target: { name: "supplier", value: e.value } }
    handleFilterChange(toFilter)
  }

  async function fetchSuppliers() {
    setSuppliers([])

    const suppliersResponse = await getAllSuppliers()

    if (suppliersResponse.error) {
      TokenExpiry(suppliersResponse)
    } else {
      suppliersResponse.data.data.map((supplier) => {
        var info = supplier
        info.trade_name = supplier.trade_name
        //  + " - braddex"
        info.type = "braddex|supplier"
        setSuppliers((prev) => [...prev, info])
      })
    }
  }

  async function handleDeletePI() {
    setIsClicked(true)
    const response = await deleteInvoice(PIID.id)

    if (response.data) {
      toast.success("Purchase Invoice Deleted Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      TokenExpiry(response)
      toast.error("Error Deleting Purchase Invoice", {
        style: toastStyle(),
      })
    }
  }

  /* add modal handler */
  const [showAddModal, setShowAddModal] = useState(false)
  const handleShowAddModal = () => setShowAddModal(true)
  const handleCloseAddModal = () => setShowAddModal(false)

  const [showGenerateBirModal, setShowGenerateBirModal] = useState(false)
  const handleShowGenerateBirModal = () => setShowGenerateBirModal(true)
  const handleCloseGenerateBirModal = () => setShowGenerateBirModal(false)

  function handleSelectChange(e, id, row) {
    setBill(row)
    if (e.target.value === "edit-pi") {
      //   if (row.po_id.includes("braddex")) {
      navigate("edit/" + id)
      //   }
    } else if (e.target.value === "print-pi") {
      //   if (row.po_id.includes("braddex")) {
      navigate("print/" + id, "_blank")
      //   }
    } else if (e.target.value === "pay-pi") {
      navigate("pay-check")
    } else if (e.target.value === "delete-pi") {
      //   if (row.po_id.includes("braddex")) {
      setPIID({ id: id, type: "" })
      handleShowDeleteModal()
      //   }
    } else if (e.target.value === "close-pi") {
      handleShowCloseBillModal()
    } else if (e.target.value === "generate-bir") {
      handleShowGenerateBirModal()
    }
  }

  function ViewPIBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.id, row)}
        value="print-pi"
      >
        View
      </button>
    )
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row.id, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="print-pi" className="color-options">
          View
        </option>
        {row.withholding_tax !== "0.00" ? (
          <option value="generate-bir" className="color-options">
            Generate BIR 2307
          </option>
        ) : null}
        {type === "overpaid" &&
        (accountType === "admin" || accountType === "purchase_officer") ? (
          <option value="close-pi" className="color-options">
            Close bill
          </option>
        ) : null}
        {isAdmin && type === "open" && (
          <option value="delete-pi" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  // async function handleGenerateBir2037() {
  //   setIsClicked(true)

  //   //yet to be changed
  //   var response = await createBir2037PurchaseInvoice(bill.id)
  //   if (response !== undefined) {
  //     //extract data from response and then feed to excel
  //     toast.success("BIR 2037 generated successfully", {
  //       style: toastStyle(),
  //     })
  //     // var success = handleExcelGeneration(response)
  //     // if (success) {
  //     //   // setTimeout(
  //     //   //   () => navigate(`/wholesaleinvoice/print/${salesInvoiceId}`),
  //     //   //   1000
  //     //   // )
  //     //   handleCloseGenerateBirModal()
  //     // } else {
  //     //   toast.error("An error occured", {
  //     //     style: toastStyle(),
  //     //   })
  //     // }
  //     handleCloseGenerateBirModal()
  //     setTimeout(() => refreshPage(), 1000)
  //   } else {
  //     response.error?.response?.data?.messages.map((data) => {
  //       return toast.error(data)
  //     })
  //     setTimeout(() => refreshPage(), 1000)
  //   }
  //   setIsClicked(false)
  // }

  async function handleGenerateBir2037() {
    setIsClicked(true)
    toast.loading("Printing Form 2307", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  useEffect(() => {
    fetchBranches()
    fetchSuppliers()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              PURCHASE INVOICE{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              placeHolder="Search..."
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={handleShowAddModal}>
                Add
              </button>
            </div>
          </Col>
        </Row>

        <Tabs
          activeKey={filterConfig.payment_status}
          defaultActiveKey={filterConfig.payment_status}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="open" title="Open Bills">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  options={branches}
                  onChange={(e) => {
                    setCurrentPage(1)
                    setFilterConfig((prev) => {
                      return { ...prev, branch_id: e.value, page: 1 }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  placeholderText={"Select Date"}
                  name="date_from"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date, page: 1 }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormat="MMM dd, yyyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  placeholderText={"Select Date"}
                  name="date_to"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date, page: 1 }
                    })
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormat="MMM dd, yyyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            {/* content */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE",
                "SUPPLIER",
                "BRANCH",
                "INV NO.",
                "DR NO.",
                "SUBTOTAL",
                "AMOUNT DUE",
                "AMT. PAID",
                "BAL.",
                "PYMNT STATS",
                "PMT REF NO",
                "RETURN DETAILS",
                "PO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "receive_date",
                "supplier",
                "branch_name",
                "invoice_no",
                "dr_no",
                "discounted_subtotal",
                "total",
                "amount_paid",
                "balance",
                "payment_status",
                "",
                "return_details",
                "po_id",
              ]}
              tableData={purchaseInvoiceManager}
              ActionBtn={(row) => ActionBtn(row, "open")}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => ContractBtn(row)}
              PendingBtn={(row) => ReturnBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="closed" title="Closed Bills">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  options={branches}
                  onChange={(e) => {
                    setCurrentPage(1)
                    setFilterConfig((prev) => {
                      return { ...prev, branch_id: e.value, page: 1 }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  placeholderText={"Select Date"}
                  name="date_from"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date, page: 1 }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormat="MMM dd, yyyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  placeholderText={"Select Date"}
                  name="date_to"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date, page: 1 }
                    })
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormat="MMM dd, yyyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            {/* content */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE",
                "SUPPLIER",
                "BRANCH",
                "INV NO.",
                "DR NO.",
                "SUBTOTAL",
                "AMOUNT DUE",
                "AMT PAID",
                "BAL",
                "PYMNT STATS",
                "PMT REF NO",
                "RETURN DETAILS",
                "PO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "receive_date",
                "supplier",
                "branch_name",
                "invoice_no",
                "dr_no",
                "discounted_subtotal",
                "total",
                "amount_paid",
                "balance",
                "payment_status",
                "",
                "return_details",
                "po_id",
              ]}
              tableData={purchaseInvoiceManager}
              ActionBtn={(row) => ActionBtn(row, "closed")}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => ContractBtn(row)}
              PendingBtn={(row) => ReturnBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="overpaid" title="Overpaid">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  options={branches}
                  onChange={(e) => {
                    setCurrentPage(1)
                    setFilterConfig((prev) => {
                      return { ...prev, branch_id: e.value, page: 1 }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  placeholderText={"Select Date"}
                  name="date_from"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date, page: 1 }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormat="MMM dd, yyyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  placeholderText={"Select Date"}
                  name="date_to"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date, page: 1 }
                    })
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormat="MMM dd, yyyyy"
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            {/* content */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE",
                "SUPPLIER",
                "BRANCH",
                "INV NO.",
                "DR NO.",
                "SUBTOTAL",
                "AMOUNT DUE",
                "AMT PAID",
                "OVERPAID AMT",
                "PYMNT STATS",
                "PMT REF NO",
                "RETURN DETAILS",
                "PO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "receive_date",
                "supplier",
                "branch_name",
                "invoice_no",
                "dr_no",
                "discounted_subtotal",
                "total",
                "amount_paid",
                "overpaid_amount",
                "payment_status",
                "",
                "return_details",
                "po_id",
              ]}
              tableData={purchaseInvoiceManager}
              ActionBtn={(row) => ActionBtn(row, "overpaid")}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => ContractBtn(row)}
              PendingBtn={(row) => ReturnBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="all" title="All">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Branch"
                  styles={selectDropdownStyle}
                  options={branches}
                  onChange={(e) => {
                    setCurrentPage(1)
                    setFilterConfig((prev) => {
                      return { ...prev, branch_id: e.value, page: 1 }
                    })
                  }}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  placeholderText={"Select Date"}
                  name="date_from"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date, page: 1 }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMM dd, yyyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  placeholderText={"Select Date"}
                  name="date_to"
                  onChange={(date) => {
                    setCurrentPage(1)
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date, page: 1 }
                    })
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMM dd, yyyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            {/* content */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE",
                "SUPPLIER",
                "BRANCH",
                "INV NO.",
                "DR NO.",
                "SUBTOTAL",
                "AMOUNT DUE",
                "AMT PAID",
                "BAL",
                "PYMNT STATS",
                "PMT REF NO",
                "RETURN DETAILS",
                "PO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "receive_date",
                "supplier",
                "branch_name",
                "invoice_no",
                "dr_no",
                "discounted_subtotal",
                "total",
                "amount_paid",
                "balance",
                "payment_status",
                "",
                "return_details",
                "po_id",
              ]}
              tableData={purchaseInvoiceManager}
              ActionBtn={(row) => ActionBtn(row, "all")}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => ContractBtn(row)}
              PendingBtn={(row) => ReturnBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
        <Row className="mt-3">
          <Col lg={10}></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button type="button" class="primary-btn" onClick={handleExport}>
                <span className="me-2">
                  <img
                    alt="download"
                    width={20}
                    height={20}
                    src={downloadIcon}
                  ></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-2" />
        <br />
        <br />
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="purchase invoice"
        onDelete={() => handleDeletePI()}
        isClicked={isClicked}
      />
      <AddModal show={showAddModal} hide={handleCloseAddModal} />
      <CloseBillModal
        show={showCloseBillModal}
        hide={handleCloseCloseBillModal}
        type="close"
        selectedRow={bill}
        page={"view"}
      />
      <GenerateBirModal
        show={showGenerateBirModal}
        hide={() => handleCloseGenerateBirModal()}
        message="Are you sure you want to Generate BIR 2307 for this purchase invoice?"
        handler={() => handleGenerateBir2037()}
        isClicked={isClicked}
      />
      <BirForm id={bill.id} type="purchase-invoice" />
      <Footer />
    </div>
  )
}
